export const BoPhanSuDungCCDCSearchColumns = [
  { field: 'ma_bp', headerName: 'Mã bộ phận', width: 150 },
  { field: 'ten_bp', headerName: 'Tên bộ phận', width: 250 }
];

export const ccdcSearchColumns = [
  { field: 'ma_cc', headerName: 'Mã công cụ', width: 150 },
  { field: 'ten_cc', headerName: 'Tên công cụ', width: 250 }
];
